import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { instanceAPIPrivate } from 'config/axiosconfig';

const axiosConfig = {
  withCredentials: true,
};

export const setFinalWinner = createAsyncThunk(
  'finalWinner',
  async (dataWinner) => {
    const finalWinner = await instanceAPIPrivate.post('/register-information', dataWinner, axiosConfig)
      .then((resp) => resp.data)
      .catch((err) => err.response.data);
    return finalWinner;
  },
);

const finalWinnerSlice = createSlice({
  name: 'finalWinner',
  initialState: {
    winner: {},
    statusDataWinner: '',
  },
  extraReducers: {
    [setFinalWinner.pending]: (state) => {
      state.statusDataWinner = 'loading';
    },
    [setFinalWinner.fulfilled]: (state, action) => {
      state.statusDataWinner = 'success';
      state.winner = action.payload;
    },
    [setFinalWinner.rejected]: (state) => {
      state.statusDataWinner = 'failed';
    },
  },
  reducers: {
    resetFinalWinner: (state) => {
      state.winner = {};
      state.statusDataWinner = '';
    },
  },
});

export const { resetFinalWinner } = finalWinnerSlice.actions;
export default finalWinnerSlice.reducer;
